import { BASE_URL } from './config'

async function fetchWithHandling(url: string, options: RequestInit) {
  const response = await fetch(url, options)
  if (!response.ok) {
    let errorMessage = 'An error occurred'
    try {
      const errorData = await response.json()
      errorMessage = errorData.message || errorMessage
    } catch (e) {
      errorMessage = response.statusText
    }
    throw new Error(errorMessage)
  }
  return response.json()
}

export async function registerUser(data: any) {
  return fetchWithHandling(`${BASE_URL}/auth/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
}

export async function loginUser(data: any) {
  return fetchWithHandling(`${BASE_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
}

export async function getMe(token: string) {
  return fetchWithHandling(`${BASE_URL}/auth/me`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export async function forgotPassword(email: string) {
  return fetchWithHandling(`${BASE_URL}/auth/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  })
}

export async function resetPassword(token: string, password: string) {
  return fetchWithHandling(`${BASE_URL}/auth/reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token, password }),
  })
}

export async function updateProfile(
  token: string,
  data: { fullName?: string; phone?: string },
) {
  return fetchWithHandling(`${BASE_URL}/auth/profile`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
}

export async function deleteAccount(token: string) {
  return fetchWithHandling(`${BASE_URL}/auth/account`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}
